module.exports = {
  "mode": "compressed",
  "staticDomainPrefix": "//static.hsappstatic.net",
  "bender": {
    "depVersions": {
      "conversations-visitor-ui": "static-1.28227",
      "ably": "static-2.2",
      "data-fetching-client": "static-1.9445",
      "ably-hubspot-js": "static-2.4482",
      "atom": "static-1.4838",
      "conversations-async-data": "static-2.7428",
      "conversations-error-reporting": "static-1.8644",
      "conversations-internal-pub-sub": "static-1.15726",
      "conversations-internal-schema": "static-1.12430",
      "conversations-message-history": "static-1.11937",
      "conversations-test-sdk": "static-1.10266",
      "conversations-visitor-experience-components": "static-1.21590",
      "head-dlb": "static-1.4754",
      "hs-promise-utils": "static-1.5359",
      "hs-test-utils": "static-1.7773",
      "hubspot-dlb": "static-2.1796",
      "HubStyleTokens": "static-2.11187",
      "I18n": "static-7.1561",
      "immer": "static-1.33",
      "jasmine-immutable": "static-1.2786",
      "jasmine-runner": "static-1.6241",
      "quartz": "static-1.6683",
      "react-dlb": "static-1.71",
      "react-select-plus": "static-1.65",
      "react-transition-group": "static-2.60",
      "redux-thunk": "static-2.43",
      "sanitize": "static-1.4242",
      "StyleGuideUI": "static-3.483",
      "transmute": "static-2.85",
      "urlinator": "static-1.4302",
      "usage-tracker": "static-1.7101",
      "usage-tracker-core": "static-1.6951",
      "usage-tracker-public": "static-1.6912",
      "viral-links-lib": "static-1.6796",
      "visitor-ui-component-library": "static-1.5898",
      "webpack-env": "static-1.54",
      "autolinker": "static-3.11",
      "classnames": "static-2.10",
      "conversations-http": "static-1.4578",
      "conversations-prop-types": "static-1.7219",
      "conversations-visitor-message-history": "static-1.20327",
      "cssUtils": "static-1.723",
      "enviro": "static-4.387",
      "flux-actions": "static-1.304",
      "foundations-components": "static-1.7460",
      "hs-lodash": "static-4.45",
      "hub-http": "static-1.5966",
      "hubspot-url-utils": "static-1.3917",
      "immutable": "static-2.19",
      "metrics-js": "static-1.9391",
      "PatternValidationJS": "static-1.437",
      "PortalIdParser": "static-2.349",
      "raven": "static-3.5624",
      "react": "static-7.177",
      "react-aria": "static-1.61",
      "react-dom": "static-7.85",
      "react-redux": "static-7.66",
      "react-rhumb": "static-1.16408",
      "react-utils": "static-2.5144",
      "redux": "static-4.16",
      "redux-toolkit": "static-1.7",
      "reselect": "static-2.16",
      "sanitize-text": "static-1.7908",
      "signup-constants": "static-1.18325",
      "styled-components": "static-2.84",
      "usage-tracker-multi": "static-1.5515",
      "visitor-ui-component-library-icons": "static-1.5709",
      "hs-promise-rejection-tracking": "static-1.5291",
      "raven-hubspot": "static-1.5931",
      "hoist-non-react-statics": "static-3.9",
      "bend-plugin-trellis-migration": "static-1.3195",
      "moment": "static-3.26",
      "apollo-stack-hubspot": "static-3.81",
      "fast-json-stable-stringify": "static-1.4",
      "graphql": "static-1.77",
      "quartz-config": "static-1.461",
      "quartz-core": "static-1.5902",
      "react-immutable-proptypes": "static-2.8",
      "foundations-assets": "static-1.4600",
      "foundations-theming": "static-1.4176",
      "UIComponents": "static-3.8134",
      "customer-data-email": "static-1.17616",
      "cv-backend-services": "static-1.1488",
      "immutable-less": "static-1.4421",
      "conversations-skeleton-state": "static-1.7017",
      "crm-events-viz-core": "static-1.32339",
      "customer-agent-discovery-components-lib": "static-1.2354",
      "customer-data-objects": "static-1.7412",
      "icons": "static-2.618",
      "react-input-autosize": "static-2.17",
      "react-router-dom": "static-5.26",
      "rpc-client-utils": "static-1.4399",
      "ui-images": "static-2.1083",
      "HeadJS": "static-2.703",
      "framer-motion": "static-1.67",
      "hs-test-utils-bend-plugin": "static-1.2884",
      "msw": "static-1.39",
      "testing-library": "static-1.147",
      "i18n-data": "static-1.216",
      "moment-timezone": "static-5.78",
      "jasmine": "static-4.4098",
      "history": "static-4.47",
      "signup-ui-url-generator": "static-2.7831",
      "HubStyle": "static-2.11495",
      "quartz-i18n": "static-1.358",
      "sassPrefix": "static-1.151",
      "bend-plugin-foundations-components": "static-1.3729",
      "floating-ui": "static-1.51",
      "foundations-theming-specialty": "static-1.1892",
      "hs-story-utils": "static-1.9196",
      "react-virtualized": "static-2.94",
      "tanstack-table": "static-1.50",
      "trellis-assets": "static-1.1101",
      "ui-fonts": "static-1.449",
      "csstype": "static-1.50",
      "quick-fetch": "static-1.3703",
      "usage-tracker-anonymous": "static-1.5518",
      "bender-build-tools": "static-1.2903",
      "dispatcher": "static-1.130",
      "general-store": "static-6.20",
      "hub-http-janus": "static-1.786",
      "hubspotter-http": "static-1.4448",
      "mobile-manifest-mixins": "static-1.476",
      "module-federation": "static-1.18",
      "quartz-auth": "static-1.358",
      "quartz-head": "static-1.348",
      "quartz-routing": "static-1.113",
      "quartz-test": "static-1.358",
      "usage-tracker-container": "static-1.7091",
      "bend-plugin-foundations-theming": "static-1.2659",
      "foundations-theming-base": "static-1.3161",
      "stylex": "static-1.27",
      "apollo-dlb": "static-3.80",
      "apollo-link-hub-http": "static-2.4417",
      "customer-data-ui-utilities": "static-1.9592",
      "FileManagerCore": "static-1.38292",
      "FileManagerLib": "static-1.38433",
      "hubspot-apollo-client": "static-1.4647",
      "react-immutable-render-mixin": "static-1.9",
      "salesImages": "static-1.520",
      "timezone-utils": "static-2.5012",
      "ui-gdpr-components": "static-1.10114",
      "ts-schema": "static-1.3874",
      "avatar-components": "static-1.2253",
      "content-assistance-lib": "static-1.7400",
      "crm-component-utils": "static-1.38404",
      "crm-display-components": "static-1.24154",
      "crm-fe-perf": "static-1.22675",
      "crm-links": "static-1.6022",
      "crm-message-bus": "static-1.42253",
      "crm-search-service-types": "static-1.921",
      "crm-source-interpretation-lib": "static-1.5099",
      "customer-data-communicator": "static-1.44832",
      "customer-data-filters-ui": "static-1.38768",
      "customer-data-objects-ui-components": "static-1.12771",
      "customer-data-properties": "static-1.50693",
      "customer-data-rte": "static-1.32370",
      "draft-plugins": "static-2.21256",
      "file-manager-components": "static-1.22793",
      "framework-data-schema-resolvers": "static-1.6637",
      "frontend-preferences-client": "static-1.7691",
      "hubspot-prosemirror": "static-1.17513",
      "object-comments-thread-lib": "static-1.10004",
      "reference-resolvers-lite": "static-1.7857",
      "ui-addon-upgrades": "static-9.17601",
      "universal-associations-select": "static-1.10748",
      "ai-components-ui-library": "static-1.8264",
      "final-form": "static-1.65",
      "ui-addon-video-player": "static-1.8463",
      "inbound-db-properties-service-client": "static-1.3646",
      "property-translator": "static-1.5181",
      "hub-http-shared-msw-handlers": "static-1.9400",
      "hubspotter-http-shared-msw-handlers": "static-1.9398",
      "react-dnd-compat": "static-1.4391",
      "audio-components": "static-1.5565",
      "cropperjs": "static-1.10",
      "FileManagerImages": "static-1.35944",
      "immerable": "static-1.3922",
      "ui-universal-auth": "static-1.8647",
      "video-components": "static-1.12482",
      "video-data-lib": "static-1.34137",
      "video-embed": "static-1.34971",
      "hubspot-apollo-cache": "static-1.106",
      "superstore": "static-1.4539",
      "ui-coaching-tips": "static-1.27859",
      "card-properties-lib": "static-1.43429",
      "crm-actions": "static-1.6062",
      "crm-cards-data": "static-1.1144",
      "crm-cards-sdk": "static-1.42815",
      "customer-data-properties-shared-msw-handlers": "static-1.8727",
      "customer-data-property-utils": "static-1.7839",
      "customer-data-tracking": "static-1.6650",
      "inbound-db-meta-service-client": "static-1.3397",
      "framework-data-table": "static-2.11338",
      "location-customization-utils-lib": "static-1.8455",
      "calling-error-reporting": "static-1.31066",
      "calling-internal-common": "static-1.31060",
      "calling-usage-tracker": "static-1.6306",
      "crm_data": "static-4.91111",
      "customer-data-content": "static-1.26818",
      "draft-content-plugins": "static-1.27638",
      "draft-convert": "static-2.67",
      "draft-email-branding-plugin": "static-2.23626",
      "draft-extend": "static-3.70",
      "draft-js": "static-5.72",
      "draft-signature-plugin": "static-1.23440",
      "EmailSignatureEditor": "static-1.23859",
      "hubspot-prosemirror-plugins": "static-1.17505",
      "integration-settings-components": "static-1.14703",
      "integrations-lib": "static-1.15313",
      "integrations-tracking-lib": "static-1.5351",
      "native-integrations-shared-strings": "static-1.7556",
      "nav-meta": "static-1.28803",
      "onboarding-scopes": "static-1.6232",
      "outreach-assistant-email-generation": "static-1.5713",
      "prosemirror": "static-1.13",
      "quotes-client-types": "static-1.37125",
      "react-colorpicker": "static-2.9980",
      "reference-resolvers": "static-1.7927",
      "rich-text-lib": "static-1.19418",
      "sales-email-signature-service-client": "static-1.3612",
      "sequences-lib": "static-1.7638",
      "ui-addon-i18n": "static-1.10899",
      "ui-addon-iframeable": "static-1.8809",
      "ui-business-units-lib": "static-1.8790",
      "ui-shepherd-react": "static-3.9912",
      "user-context": "static-1.4862",
      "whatsapp-sending-lib": "static-1.4842",
      "customer-data-filters-ui-msw-helpers": "static-1.21202",
      "customer-data-reference-ui-components": "static-1.12910",
      "FormUrlGenerator": "static-2.4498",
      "framework-builder-read-service-client": "static-1.3817",
      "framework-data-schema-quick-fetch": "static-1.6542",
      "multi-account-reference-resolvers": "static-1.736",
      "onboarding-tours": "static-1.16213",
      "reporting-datasets-permissions-lib": "static-1.12961",
      "SharedI18nStrings": "static-1.180",
      "ui-addon-teams": "static-1.21195",
      "calling-global-api": "static-1.63545",
      "calling-lifecycle-internal": "static-1.64927",
      "calling-lifecycle-messages": "static-1.57221",
      "commerce-products-lib": "static-1.8759",
      "conditional-properties-service-client": "static-1.3594",
      "external-options-client-types": "static-1.3954",
      "google-libphonenumber": "static-1.33",
      "hs-entities": "static-1.439",
      "inbounddb-objects-service-types": "static-1.4020",
      "meetings-icalendar-utils-lib": "static-1.402",
      "multi-currency-client-types": "static-1.3488",
      "object-builder-ui-client": "static-1.47864",
      "pipeline-validation-client-types": "static-1.3757",
      "property-value-citations": "static-1.1307",
      "pulse": "static-1.271",
      "smart-property-lib": "static-1.5760",
      "tiered-pricing": "static-1.780",
      "ui-addon-form-validation": "static-1.10762",
      "video-components-external": "static-1.10479",
      "batch-promise": "static-1.1318",
      "crm-pipelines-api-client-types": "static-1.3935",
      "persist-promise": "static-1.3475",
      "emoji-mart": "static-3.4",
      "growth-payments-core": "static-1.24634",
      "knowledge-content-types": "static-1.8336",
      "payment-link-components": "static-1.22848",
      "ui-addon-emoji-picker": "static-1.9657",
      "call-summary": "static-1.38236",
      "reference-resolvers-lite-shared-msw-handlers": "static-1.9546",
      "laboratory-lib": "static-3.6930",
      "merchandise-lib": "static-1.257",
      "purchase-motions-components": "static-1.5437",
      "self-service-api": "static-1.10004",
      "upgrade-management-service-types": "static-1.4275",
      "chatspot-core": "static-1.20184",
      "chirp-fetch": "static-1.1651",
      "ContentUtils": "static-1.67527",
      "copilot-toolkit": "static-1.10442",
      "react-dnd": "static-5.6",
      "react-dnd-html5-backend": "static-5.6",
      "unified-auth-core-lib": "static-1.442",
      "content-icons-ui": "static-1.2144",
      "social-insights-client-types": "static-1.21264",
      "outpost": "static-1.3975",
      "growth-onboarding-feedback-components": "static-1.6353",
      "customer-data-sidebar": "static-2.45327",
      "enrichment-properties-lib": "static-1.14878",
      "customer-data-associations": "static-1.7104",
      "deal-intel-decorators": "static-1.1128",
      "reporting-data": "static-1.66382",
      "tanstack-virtual": "static-1.25",
      "ui-addon-draggable": "static-3.4533",
      "crm-record-cards-service-types": "static-1.3422",
      "crm_universal": "static-1.21608",
      "SalesContentIndexUI": "static-3.8852",
      "signup-ui-lego-core": "static-1.20335",
      "content-embed-lib": "static-1.7109",
      "data-model-builder-lib": "static-1.11566",
      "remote-ui": "static-1.60",
      "ui-components-test-utils": "static-1.5325",
      "ui-extensions-remote-renderer": "static-1.16290",
      "universal-page-editor-lib": "static-1.2763",
      "integrations-error-boundary-lib": "static-1.12728",
      "redux-observable": "static-1.11",
      "ReduxMessenger": "static-2.10140",
      "rxjs": "static-5.10",
      "messaging-types-lib": "static-1.45296",
      "data-token-picker": "static-1.15991",
      "sequences-client-types-lib": "static-1.7495",
      "foundations-components-test-utils": "static-1.4943",
      "magpie-lib": "static-1.5362",
      "navigation-messaging": "static-1.6493",
      "getting-started-shared-tasks": "static-1.17790",
      "getting-started-shared-tasks-store": "static-1.16908",
      "onboarding-tours-utils": "static-1.279",
      "messaging-usage-based-billing-components-lib": "static-1.421",
      "whatsapp-management-lib": "static-1.8001",
      "growth-data-modal": "static-1.5118",
      "growth-onboarding-confetti": "static-1.2838",
      "growth-onboarding-next-action-utils": "static-1.1262",
      "navigation-components": "static-1.17166",
      "onboarding-tours-client": "static-1.4427",
      "ui-shepherd-tracker": "static-1.7293",
      "shared-worker-versioning": "static-1.10805",
      "voice-sms-access-library": "static-1.149",
      "products-iframe-lib": "static-1.7228",
      "products-ui-components-shared-msw-handlers": "static-1.9782",
      "directed-graph": "static-1.705",
      "event-emitter": "static-1.715",
      "breeze-intelligence-kit": "static-1.5273",
      "framework-data-schema-resolvers-shared-msw-handlers": "static-1.9483",
      "fsm": "static-1.3499",
      "policy-lib": "static-1.6552",
      "react-tinymce": "static-1.54534",
      "tinymce": "static-5.11",
      "tinymce-config": "static-2.53660",
      "tinymce-plugins": "static-1.56774",
      "tinymce-themes": "static-1.55630",
      "content-media-composition-data-lib": "static-1.11335",
      "content-media-compositions": "static-2.15342",
      "idb-keyval": "static-1.39",
      "magpie-types": "static-1.4822",
      "media-bridge-lib": "static-1.18513",
      "ui-addon-opt": "static-4.8153",
      "commerce-tours-lib": "static-1.5668",
      "growth-onboarding-reliability": "static-1.4856",
      "sales-checkout-service-client": "static-1.3445",
      "ai-addon-copilot-preview": "static-1.7476",
      "calling-cross-tab-library": "static-1.19036",
      "calling-lifecycle-usage-tracker": "static-1.8050",
      "wootric-nps": "static-1.6749",
      "growth-monetization-service-types": "static-1.4291",
      "nav-client-types": "static-1.2123",
      "purchase-motions-api": "static-1.5440",
      "trials-service-types": "static-1.3692",
      "markdown-it": "static-1.6",
      "cms-field-types": "static-1.4574",
      "underscore": "static-1.8",
      "simple-logging-lib": "static-1.2818",
      "card-payment-highlight-lib": "static-1.36412",
      "card-subscription-highlight-lib": "static-1.38768",
      "commerce-billing-lib": "static-1.18408",
      "commerce-contract-lib": "static-1.11041",
      "invoices-highlight-card-lib": "static-1.53902",
      "orders-highlight-card-lib": "static-1.20795",
      "products-highlight-card-lib": "static-1.17043",
      "project-storage": "static-1.4500",
      "quotes-highlight-card-lib": "static-1.71037",
      "usage-based-billing-components-lib": "static-1.7926",
      "deal-intel-utils": "static-1.1132",
      "reporting-client-types": "static-1.2376",
      "react-flip-move": "static-1.65",
      "FireAlarmUi": "static-1.4298",
      "sales-templates-service-types-lib": "static-1.3964",
      "ui-asset-management-lib": "static-1.10665",
      "emoji-regex": "static-1.7",
      "association-settings-lib": "static-1.9556",
      "collaboration-sidebar": "static-1.57054",
      "conditional-property-settings-modal": "static-1.11870",
      "data-model-commons-lib": "static-1.11855",
      "feedback-loader": "static-1.28792",
      "html-to-image": "static-1.49",
      "object-definition-builder-lib": "static-1.6831",
      "property-management-iframe": "static-1.12184",
      "property-usages-lib": "static-1.5158",
      "reactflow": "static-1.59",
      "simple-data-table": "static-1.2095",
      "used-in-list-lib": "static-1.6686",
      "visual-association": "static-1.5614",
      "highcharts": "static-8.99",
      "reporting-visualizations": "static-1.58458",
      "ui-extensibility-client-types": "static-1.3716",
      "automation-platform-service-types": "static-1.2476",
      "ContentData": "static-1.67602",
      "email-portal-health-service-types": "static-1.745",
      "marketing-email-service-types": "static-1.1770",
      "reactive-lib": "static-1.494",
      "content-whatsapp-service-types": "static-1.236",
      "marketing-platform-lib": "static-1.6602",
      "short-messages-app-service-client": "static-1.3780",
      "ui-tool-access": "static-1.9911",
      "calling-orchestration-schema": "static-1.34926",
      "sales-views-client-types": "static-1.4059",
      "trellis-story-utils": "static-1.4291",
      "storybook-react": "static-1.28",
      "hub-http-contrib": "static-1.2812",
      "interframe": "static-3.4559",
      "tinymce-data": "static-1.39745",
      "ui-addon-sales-email": "static-1.4981",
      "codemirror": "static-5.90",
      "layout-dnd-components": "static-1.11974",
      "layout-dnd-utils": "static-1.10949",
      "react-codemirror": "static-1.10394",
      "ui-brand-identity-lib": "static-1.13705",
      "NamespacedHubStyle": "static-2.8867",
      "hls.js": "static-1.34",
      "js-cookie": "static-1.18",
      "ai-rendering-library": "static-1.9204",
      "ai-settings-ui-library": "static-1.7350",
      "copilot-plugins": "static-1.10415",
      "eligibility-engine-service-types": "static-1.2973",
      "commerce-shared-components-lib": "static-1.17834",
      "commerce-subscription-lib": "static-1.36345",
      "commerce-tools-ui-lib": "static-1.9712",
      "usage-tracker-session-replay": "static-1.4787",
      "utility-belt": "static-1.2310",
      "payments-enrollment-embed-lib": "static-1.21870",
      "products-ui-components": "static-1.39278",
      "quotes-ui-lib": "static-1.79756",
      "zustand": "static-1.51",
      "accounting-integrations-ui-components": "static-1.6676",
      "invoices-ui-lib": "static-1.53918",
      "commerce-products-api": "static-1.1909",
      "SafeStorage": "static-1.4172",
      "invoices-iframe-lib": "static-1.55976",
      "quotes-modal-lib": "static-1.101713",
      "platform-infra-nav-components": "static-1.7463",
      "reporting-ui-components": "static-2.63653",
      "subscription-experience-data-types": "static-1.14544",
      "association-translator": "static-1.2960",
      "crm-settings-header-lib": "static-1.8079",
      "settings-ui-nav": "static-2.9940",
      "chatspot-widget-iframe": "static-1.20176",
      "collaboration-sidebar-common": "static-1.1851",
      "crm-properties-common-lib": "static-1.5639",
      "ui-addon-draggable-compat": "static-2.4021",
      "property-management-common": "static-1.4471",
      "d3": "static-1.7",
      "advanced-menus-core": "static-1.14769",
      "advanced-menus-lib": "static-1.11751",
      "ExportDialog": "static-6.10156",
      "ui-memberships-settings-lib": "static-1.33343",
      "diff-match-patch": "static-1.7",
      "layout-data-lib": "static-1.9274",
      "browser-eslint": "static-2.57",
      "embedded-academy-lib": "static-1.13390",
      "highlight.js": "static-1.74",
      "reporting-action-components": "static-1.40568",
      "reporting-snowflake": "static-1.55000",
      "ui-addon-react-router-dom": "static-1.9316",
      "growth-onboarding-empty-states": "static-1.5315",
      "InboxConnectUtils": "static-4.14141",
      "payments-post-enroll-local-storage-lib": "static-1.4880",
      "qrcode-generator": "static-1.64",
      "amplitude-session-replay-browser": "static-1.55",
      "marketplace-ui-apps-core": "static-1.17386",
      "stripe-embedded-components": "static-1.7080",
      "commerce-permissions": "static-1.520",
      "commerce-tax-lib": "static-1.276",
      "property-description-translator": "static-1.3627",
      "commerce-analytics-service-client": "static-1.3433",
      "totals-ui-components": "static-1.22919",
      "reporting-plugins": "static-1.9940",
      "reporting-reports": "static-1.66060",
      "edison-service-client-types": "static-1.158",
      "seamless-immutable": "static-7.6",
      "simple-menus-core": "static-1.14768",
      "simple-menus-lib": "static-1.16285",
      "academy-common-lib": "static-1.12850",
      "dashboard-lib": "static-1.80482",
      "share-with-third-party-component-lib": "static-1.8458",
      "developer-experience-shared-components": "static-1.10235",
      "marketplace-ui-client-types": "static-1.16260",
      "marketplace-ui-common": "static-1.18853",
      "ui-addon-integrations-directory-panel": "static-2.7752",
      "stripe-connect-js": "static-1.63",
      "commerce-totals-service-types": "static-1.3608",
      "campaign-roi-lib": "static-1.8182",
      "academy-service-client": "static-1.3449",
      "redux-actions": "static-3.7",
      "apps-service-types": "static-1.3646",
      "oauth-service-types": "static-1.4008",
      "react-window": "static-1.13"
    },
    "depPathPrefixes": {
      "conversations-visitor-ui": "/conversations-visitor-ui/static-1.28227",
      "ably": "/ably/static-2.2",
      "data-fetching-client": "/data-fetching-client/static-1.9445",
      "ably-hubspot-js": "/ably-hubspot-js/static-2.4482",
      "atom": "/atom/static-1.4838",
      "conversations-async-data": "/conversations-async-data/static-2.7428",
      "conversations-error-reporting": "/conversations-error-reporting/static-1.8644",
      "conversations-internal-pub-sub": "/conversations-internal-pub-sub/static-1.15726",
      "conversations-internal-schema": "/conversations-internal-schema/static-1.12430",
      "conversations-message-history": "/conversations-message-history/static-1.11937",
      "conversations-test-sdk": "/conversations-test-sdk/static-1.10266",
      "conversations-visitor-experience-components": "/conversations-visitor-experience-components/static-1.21590",
      "head-dlb": "/head-dlb/static-1.4754",
      "hs-promise-utils": "/hs-promise-utils/static-1.5359",
      "hs-test-utils": "/hs-test-utils/static-1.7773",
      "hubspot-dlb": "/hubspot-dlb/static-2.1796",
      "HubStyleTokens": "/HubStyleTokens/static-2.11187",
      "I18n": "/I18n/static-7.1561",
      "immer": "/immer/static-1.33",
      "jasmine-immutable": "/jasmine-immutable/static-1.2786",
      "jasmine-runner": "/jasmine-runner/static-1.6241",
      "quartz": "/quartz/static-1.6683",
      "react-dlb": "/react-dlb/static-1.71",
      "react-select-plus": "/react-select-plus/static-1.65",
      "react-transition-group": "/react-transition-group/static-2.60",
      "redux-thunk": "/redux-thunk/static-2.43",
      "sanitize": "/sanitize/static-1.4242",
      "StyleGuideUI": "/StyleGuideUI/static-3.483",
      "transmute": "/transmute/static-2.85",
      "urlinator": "/urlinator/static-1.4302",
      "usage-tracker": "/usage-tracker/static-1.7101",
      "usage-tracker-core": "/usage-tracker-core/static-1.6951",
      "usage-tracker-public": "/usage-tracker-public/static-1.6912",
      "viral-links-lib": "/viral-links-lib/static-1.6796",
      "visitor-ui-component-library": "/visitor-ui-component-library/static-1.5898",
      "webpack-env": "/webpack-env/static-1.54",
      "autolinker": "/autolinker/static-3.11",
      "classnames": "/classnames/static-2.10",
      "conversations-http": "/conversations-http/static-1.4578",
      "conversations-prop-types": "/conversations-prop-types/static-1.7219",
      "conversations-visitor-message-history": "/conversations-visitor-message-history/static-1.20327",
      "cssUtils": "/cssUtils/static-1.723",
      "enviro": "/enviro/static-4.387",
      "flux-actions": "/flux-actions/static-1.304",
      "foundations-components": "/foundations-components/static-1.7460",
      "hs-lodash": "/hs-lodash/static-4.45",
      "hub-http": "/hub-http/static-1.5966",
      "hubspot-url-utils": "/hubspot-url-utils/static-1.3917",
      "immutable": "/immutable/static-2.19",
      "metrics-js": "/metrics-js/static-1.9391",
      "PatternValidationJS": "/PatternValidationJS/static-1.437",
      "PortalIdParser": "/PortalIdParser/static-2.349",
      "raven": "/raven/static-3.5624",
      "react": "/react/static-7.177",
      "react-aria": "/react-aria/static-1.61",
      "react-dom": "/react-dom/static-7.85",
      "react-redux": "/react-redux/static-7.66",
      "react-rhumb": "/react-rhumb/static-1.16408",
      "react-utils": "/react-utils/static-2.5144",
      "redux": "/redux/static-4.16",
      "redux-toolkit": "/redux-toolkit/static-1.7",
      "reselect": "/reselect/static-2.16",
      "sanitize-text": "/sanitize-text/static-1.7908",
      "signup-constants": "/signup-constants/static-1.18325",
      "styled-components": "/styled-components/static-2.84",
      "usage-tracker-multi": "/usage-tracker-multi/static-1.5515",
      "visitor-ui-component-library-icons": "/visitor-ui-component-library-icons/static-1.5709",
      "hs-promise-rejection-tracking": "/hs-promise-rejection-tracking/static-1.5291",
      "raven-hubspot": "/raven-hubspot/static-1.5931",
      "hoist-non-react-statics": "/hoist-non-react-statics/static-3.9",
      "bend-plugin-trellis-migration": "/bend-plugin-trellis-migration/static-1.3195",
      "moment": "/moment/static-3.26",
      "apollo-stack-hubspot": "/apollo-stack-hubspot/static-3.81",
      "fast-json-stable-stringify": "/fast-json-stable-stringify/static-1.4",
      "graphql": "/graphql/static-1.77",
      "quartz-config": "/quartz-config/static-1.461",
      "quartz-core": "/quartz-core/static-1.5902",
      "react-immutable-proptypes": "/react-immutable-proptypes/static-2.8",
      "foundations-assets": "/foundations-assets/static-1.4600",
      "foundations-theming": "/foundations-theming/static-1.4176",
      "UIComponents": "/UIComponents/static-3.8134",
      "customer-data-email": "/customer-data-email/static-1.17616",
      "cv-backend-services": "/cv-backend-services/static-1.1488",
      "immutable-less": "/immutable-less/static-1.4421",
      "conversations-skeleton-state": "/conversations-skeleton-state/static-1.7017",
      "crm-events-viz-core": "/crm-events-viz-core/static-1.32339",
      "customer-agent-discovery-components-lib": "/customer-agent-discovery-components-lib/static-1.2354",
      "customer-data-objects": "/customer-data-objects/static-1.7412",
      "icons": "/icons/static-2.618",
      "react-input-autosize": "/react-input-autosize/static-2.17",
      "react-router-dom": "/react-router-dom/static-5.26",
      "rpc-client-utils": "/rpc-client-utils/static-1.4399",
      "ui-images": "/ui-images/static-2.1083",
      "HeadJS": "/HeadJS/static-2.703",
      "framer-motion": "/framer-motion/static-1.67",
      "hs-test-utils-bend-plugin": "/hs-test-utils-bend-plugin/static-1.2884",
      "msw": "/msw/static-1.39",
      "testing-library": "/testing-library/static-1.147",
      "i18n-data": "/i18n-data/static-1.216",
      "moment-timezone": "/moment-timezone/static-5.78",
      "jasmine": "/jasmine/static-4.4098",
      "history": "/history/static-4.47",
      "signup-ui-url-generator": "/signup-ui-url-generator/static-2.7831",
      "HubStyle": "/HubStyle/static-2.11495",
      "quartz-i18n": "/quartz-i18n/static-1.358",
      "sassPrefix": "/sassPrefix/static-1.151",
      "bend-plugin-foundations-components": "/bend-plugin-foundations-components/static-1.3729",
      "floating-ui": "/floating-ui/static-1.51",
      "foundations-theming-specialty": "/foundations-theming-specialty/static-1.1892",
      "hs-story-utils": "/hs-story-utils/static-1.9196",
      "react-virtualized": "/react-virtualized/static-2.94",
      "tanstack-table": "/tanstack-table/static-1.50",
      "trellis-assets": "/trellis-assets/static-1.1101",
      "ui-fonts": "/ui-fonts/static-1.449",
      "csstype": "/csstype/static-1.50",
      "quick-fetch": "/quick-fetch/static-1.3703",
      "usage-tracker-anonymous": "/usage-tracker-anonymous/static-1.5518",
      "bender-build-tools": "/bender-build-tools/static-1.2903",
      "dispatcher": "/dispatcher/static-1.130",
      "general-store": "/general-store/static-6.20",
      "hub-http-janus": "/hub-http-janus/static-1.786",
      "hubspotter-http": "/hubspotter-http/static-1.4448",
      "mobile-manifest-mixins": "/mobile-manifest-mixins/static-1.476",
      "module-federation": "/module-federation/static-1.18",
      "quartz-auth": "/quartz-auth/static-1.358",
      "quartz-head": "/quartz-head/static-1.348",
      "quartz-routing": "/quartz-routing/static-1.113",
      "quartz-test": "/quartz-test/static-1.358",
      "usage-tracker-container": "/usage-tracker-container/static-1.7091",
      "bend-plugin-foundations-theming": "/bend-plugin-foundations-theming/static-1.2659",
      "foundations-theming-base": "/foundations-theming-base/static-1.3161",
      "stylex": "/stylex/static-1.27",
      "apollo-dlb": "/apollo-dlb/static-3.80",
      "apollo-link-hub-http": "/apollo-link-hub-http/static-2.4417",
      "customer-data-ui-utilities": "/customer-data-ui-utilities/static-1.9592",
      "FileManagerCore": "/FileManagerCore/static-1.38292",
      "FileManagerLib": "/FileManagerLib/static-1.38433",
      "hubspot-apollo-client": "/hubspot-apollo-client/static-1.4647",
      "react-immutable-render-mixin": "/react-immutable-render-mixin/static-1.9",
      "salesImages": "/salesImages/static-1.520",
      "timezone-utils": "/timezone-utils/static-2.5012",
      "ui-gdpr-components": "/ui-gdpr-components/static-1.10114",
      "ts-schema": "/ts-schema/static-1.3874",
      "avatar-components": "/avatar-components/static-1.2253",
      "content-assistance-lib": "/content-assistance-lib/static-1.7400",
      "crm-component-utils": "/crm-component-utils/static-1.38404",
      "crm-display-components": "/crm-display-components/static-1.24154",
      "crm-fe-perf": "/crm-fe-perf/static-1.22675",
      "crm-links": "/crm-links/static-1.6022",
      "crm-message-bus": "/crm-message-bus/static-1.42253",
      "crm-search-service-types": "/crm-search-service-types/static-1.921",
      "crm-source-interpretation-lib": "/crm-source-interpretation-lib/static-1.5099",
      "customer-data-communicator": "/customer-data-communicator/static-1.44832",
      "customer-data-filters-ui": "/customer-data-filters-ui/static-1.38768",
      "customer-data-objects-ui-components": "/customer-data-objects-ui-components/static-1.12771",
      "customer-data-properties": "/customer-data-properties/static-1.50693",
      "customer-data-rte": "/customer-data-rte/static-1.32370",
      "draft-plugins": "/draft-plugins/static-2.21256",
      "file-manager-components": "/file-manager-components/static-1.22793",
      "framework-data-schema-resolvers": "/framework-data-schema-resolvers/static-1.6637",
      "frontend-preferences-client": "/frontend-preferences-client/static-1.7691",
      "hubspot-prosemirror": "/hubspot-prosemirror/static-1.17513",
      "object-comments-thread-lib": "/object-comments-thread-lib/static-1.10004",
      "reference-resolvers-lite": "/reference-resolvers-lite/static-1.7857",
      "ui-addon-upgrades": "/ui-addon-upgrades/static-9.17601",
      "universal-associations-select": "/universal-associations-select/static-1.10748",
      "ai-components-ui-library": "/ai-components-ui-library/static-1.8264",
      "final-form": "/final-form/static-1.65",
      "ui-addon-video-player": "/ui-addon-video-player/static-1.8463",
      "inbound-db-properties-service-client": "/inbound-db-properties-service-client/static-1.3646",
      "property-translator": "/property-translator/static-1.5181",
      "hub-http-shared-msw-handlers": "/hub-http-shared-msw-handlers/static-1.9400",
      "hubspotter-http-shared-msw-handlers": "/hubspotter-http-shared-msw-handlers/static-1.9398",
      "react-dnd-compat": "/react-dnd-compat/static-1.4391",
      "audio-components": "/audio-components/static-1.5565",
      "cropperjs": "/cropperjs/static-1.10",
      "FileManagerImages": "/FileManagerImages/static-1.35944",
      "immerable": "/immerable/static-1.3922",
      "ui-universal-auth": "/ui-universal-auth/static-1.8647",
      "video-components": "/video-components/static-1.12482",
      "video-data-lib": "/video-data-lib/static-1.34137",
      "video-embed": "/video-embed/static-1.34971",
      "hubspot-apollo-cache": "/hubspot-apollo-cache/static-1.106",
      "superstore": "/superstore/static-1.4539",
      "ui-coaching-tips": "/ui-coaching-tips/static-1.27859",
      "card-properties-lib": "/card-properties-lib/static-1.43429",
      "crm-actions": "/crm-actions/static-1.6062",
      "crm-cards-data": "/crm-cards-data/static-1.1144",
      "crm-cards-sdk": "/crm-cards-sdk/static-1.42815",
      "customer-data-properties-shared-msw-handlers": "/customer-data-properties-shared-msw-handlers/static-1.8727",
      "customer-data-property-utils": "/customer-data-property-utils/static-1.7839",
      "customer-data-tracking": "/customer-data-tracking/static-1.6650",
      "inbound-db-meta-service-client": "/inbound-db-meta-service-client/static-1.3397",
      "framework-data-table": "/framework-data-table/static-2.11338",
      "location-customization-utils-lib": "/location-customization-utils-lib/static-1.8455",
      "calling-error-reporting": "/calling-error-reporting/static-1.31066",
      "calling-internal-common": "/calling-internal-common/static-1.31060",
      "calling-usage-tracker": "/calling-usage-tracker/static-1.6306",
      "crm_data": "/crm_data/static-4.91111",
      "customer-data-content": "/customer-data-content/static-1.26818",
      "draft-content-plugins": "/draft-content-plugins/static-1.27638",
      "draft-convert": "/draft-convert/static-2.67",
      "draft-email-branding-plugin": "/draft-email-branding-plugin/static-2.23626",
      "draft-extend": "/draft-extend/static-3.70",
      "draft-js": "/draft-js/static-5.72",
      "draft-signature-plugin": "/draft-signature-plugin/static-1.23440",
      "EmailSignatureEditor": "/EmailSignatureEditor/static-1.23859",
      "hubspot-prosemirror-plugins": "/hubspot-prosemirror-plugins/static-1.17505",
      "integration-settings-components": "/integration-settings-components/static-1.14703",
      "integrations-lib": "/integrations-lib/static-1.15313",
      "integrations-tracking-lib": "/integrations-tracking-lib/static-1.5351",
      "native-integrations-shared-strings": "/native-integrations-shared-strings/static-1.7556",
      "nav-meta": "/nav-meta/static-1.28803",
      "onboarding-scopes": "/onboarding-scopes/static-1.6232",
      "outreach-assistant-email-generation": "/outreach-assistant-email-generation/static-1.5713",
      "prosemirror": "/prosemirror/static-1.13",
      "quotes-client-types": "/quotes-client-types/static-1.37125",
      "react-colorpicker": "/react-colorpicker/static-2.9980",
      "reference-resolvers": "/reference-resolvers/static-1.7927",
      "rich-text-lib": "/rich-text-lib/static-1.19418",
      "sales-email-signature-service-client": "/sales-email-signature-service-client/static-1.3612",
      "sequences-lib": "/sequences-lib/static-1.7638",
      "ui-addon-i18n": "/ui-addon-i18n/static-1.10899",
      "ui-addon-iframeable": "/ui-addon-iframeable/static-1.8809",
      "ui-business-units-lib": "/ui-business-units-lib/static-1.8790",
      "ui-shepherd-react": "/ui-shepherd-react/static-3.9912",
      "user-context": "/user-context/static-1.4862",
      "whatsapp-sending-lib": "/whatsapp-sending-lib/static-1.4842",
      "customer-data-filters-ui-msw-helpers": "/customer-data-filters-ui-msw-helpers/static-1.21202",
      "customer-data-reference-ui-components": "/customer-data-reference-ui-components/static-1.12910",
      "FormUrlGenerator": "/FormUrlGenerator/static-2.4498",
      "framework-builder-read-service-client": "/framework-builder-read-service-client/static-1.3817",
      "framework-data-schema-quick-fetch": "/framework-data-schema-quick-fetch/static-1.6542",
      "multi-account-reference-resolvers": "/multi-account-reference-resolvers/static-1.736",
      "onboarding-tours": "/onboarding-tours/static-1.16213",
      "reporting-datasets-permissions-lib": "/reporting-datasets-permissions-lib/static-1.12961",
      "SharedI18nStrings": "/SharedI18nStrings/static-1.180",
      "ui-addon-teams": "/ui-addon-teams/static-1.21195",
      "calling-global-api": "/calling-global-api/static-1.63545",
      "calling-lifecycle-internal": "/calling-lifecycle-internal/static-1.64927",
      "calling-lifecycle-messages": "/calling-lifecycle-messages/static-1.57221",
      "commerce-products-lib": "/commerce-products-lib/static-1.8759",
      "conditional-properties-service-client": "/conditional-properties-service-client/static-1.3594",
      "external-options-client-types": "/external-options-client-types/static-1.3954",
      "google-libphonenumber": "/google-libphonenumber/static-1.33",
      "hs-entities": "/hs-entities/static-1.439",
      "inbounddb-objects-service-types": "/inbounddb-objects-service-types/static-1.4020",
      "meetings-icalendar-utils-lib": "/meetings-icalendar-utils-lib/static-1.402",
      "multi-currency-client-types": "/multi-currency-client-types/static-1.3488",
      "object-builder-ui-client": "/object-builder-ui-client/static-1.47864",
      "pipeline-validation-client-types": "/pipeline-validation-client-types/static-1.3757",
      "property-value-citations": "/property-value-citations/static-1.1307",
      "pulse": "/pulse/static-1.271",
      "smart-property-lib": "/smart-property-lib/static-1.5760",
      "tiered-pricing": "/tiered-pricing/static-1.780",
      "ui-addon-form-validation": "/ui-addon-form-validation/static-1.10762",
      "video-components-external": "/video-components-external/static-1.10479",
      "batch-promise": "/batch-promise/static-1.1318",
      "crm-pipelines-api-client-types": "/crm-pipelines-api-client-types/static-1.3935",
      "persist-promise": "/persist-promise/static-1.3475",
      "emoji-mart": "/emoji-mart/static-3.4",
      "growth-payments-core": "/growth-payments-core/static-1.24634",
      "knowledge-content-types": "/knowledge-content-types/static-1.8336",
      "payment-link-components": "/payment-link-components/static-1.22848",
      "ui-addon-emoji-picker": "/ui-addon-emoji-picker/static-1.9657",
      "call-summary": "/call-summary/static-1.38236",
      "reference-resolvers-lite-shared-msw-handlers": "/reference-resolvers-lite-shared-msw-handlers/static-1.9546",
      "laboratory-lib": "/laboratory-lib/static-3.6930",
      "merchandise-lib": "/merchandise-lib/static-1.257",
      "purchase-motions-components": "/purchase-motions-components/static-1.5437",
      "self-service-api": "/self-service-api/static-1.10004",
      "upgrade-management-service-types": "/upgrade-management-service-types/static-1.4275",
      "chatspot-core": "/chatspot-core/static-1.20184",
      "chirp-fetch": "/chirp-fetch/static-1.1651",
      "ContentUtils": "/ContentUtils/static-1.67527",
      "copilot-toolkit": "/copilot-toolkit/static-1.10442",
      "react-dnd": "/react-dnd/static-5.6",
      "react-dnd-html5-backend": "/react-dnd-html5-backend/static-5.6",
      "unified-auth-core-lib": "/unified-auth-core-lib/static-1.442",
      "content-icons-ui": "/content-icons-ui/static-1.2144",
      "social-insights-client-types": "/social-insights-client-types/static-1.21264",
      "outpost": "/outpost/static-1.3975",
      "growth-onboarding-feedback-components": "/growth-onboarding-feedback-components/static-1.6353",
      "customer-data-sidebar": "/customer-data-sidebar/static-2.45327",
      "enrichment-properties-lib": "/enrichment-properties-lib/static-1.14878",
      "customer-data-associations": "/customer-data-associations/static-1.7104",
      "deal-intel-decorators": "/deal-intel-decorators/static-1.1128",
      "reporting-data": "/reporting-data/static-1.66382",
      "tanstack-virtual": "/tanstack-virtual/static-1.25",
      "ui-addon-draggable": "/ui-addon-draggable/static-3.4533",
      "crm-record-cards-service-types": "/crm-record-cards-service-types/static-1.3422",
      "crm_universal": "/crm_universal/static-1.21608",
      "SalesContentIndexUI": "/SalesContentIndexUI/static-3.8852",
      "signup-ui-lego-core": "/signup-ui-lego-core/static-1.20335",
      "content-embed-lib": "/content-embed-lib/static-1.7109",
      "data-model-builder-lib": "/data-model-builder-lib/static-1.11566",
      "remote-ui": "/remote-ui/static-1.60",
      "ui-components-test-utils": "/ui-components-test-utils/static-1.5325",
      "ui-extensions-remote-renderer": "/ui-extensions-remote-renderer/static-1.16290",
      "universal-page-editor-lib": "/universal-page-editor-lib/static-1.2763",
      "integrations-error-boundary-lib": "/integrations-error-boundary-lib/static-1.12728",
      "redux-observable": "/redux-observable/static-1.11",
      "ReduxMessenger": "/ReduxMessenger/static-2.10140",
      "rxjs": "/rxjs/static-5.10",
      "messaging-types-lib": "/messaging-types-lib/static-1.45296",
      "data-token-picker": "/data-token-picker/static-1.15991",
      "sequences-client-types-lib": "/sequences-client-types-lib/static-1.7495",
      "foundations-components-test-utils": "/foundations-components-test-utils/static-1.4943",
      "magpie-lib": "/magpie-lib/static-1.5362",
      "navigation-messaging": "/navigation-messaging/static-1.6493",
      "getting-started-shared-tasks": "/getting-started-shared-tasks/static-1.17790",
      "getting-started-shared-tasks-store": "/getting-started-shared-tasks-store/static-1.16908",
      "onboarding-tours-utils": "/onboarding-tours-utils/static-1.279",
      "messaging-usage-based-billing-components-lib": "/messaging-usage-based-billing-components-lib/static-1.421",
      "whatsapp-management-lib": "/whatsapp-management-lib/static-1.8001",
      "growth-data-modal": "/growth-data-modal/static-1.5118",
      "growth-onboarding-confetti": "/growth-onboarding-confetti/static-1.2838",
      "growth-onboarding-next-action-utils": "/growth-onboarding-next-action-utils/static-1.1262",
      "navigation-components": "/navigation-components/static-1.17166",
      "onboarding-tours-client": "/onboarding-tours-client/static-1.4427",
      "ui-shepherd-tracker": "/ui-shepherd-tracker/static-1.7293",
      "shared-worker-versioning": "/shared-worker-versioning/static-1.10805",
      "voice-sms-access-library": "/voice-sms-access-library/static-1.149",
      "products-iframe-lib": "/products-iframe-lib/static-1.7228",
      "products-ui-components-shared-msw-handlers": "/products-ui-components-shared-msw-handlers/static-1.9782",
      "directed-graph": "/directed-graph/static-1.705",
      "event-emitter": "/event-emitter/static-1.715",
      "breeze-intelligence-kit": "/breeze-intelligence-kit/static-1.5273",
      "framework-data-schema-resolvers-shared-msw-handlers": "/framework-data-schema-resolvers-shared-msw-handlers/static-1.9483",
      "fsm": "/fsm/static-1.3499",
      "policy-lib": "/policy-lib/static-1.6552",
      "react-tinymce": "/react-tinymce/static-1.54534",
      "tinymce": "/tinymce/static-5.11",
      "tinymce-config": "/tinymce-config/static-2.53660",
      "tinymce-plugins": "/tinymce-plugins/static-1.56774",
      "tinymce-themes": "/tinymce-themes/static-1.55630",
      "content-media-composition-data-lib": "/content-media-composition-data-lib/static-1.11335",
      "content-media-compositions": "/content-media-compositions/static-2.15342",
      "idb-keyval": "/idb-keyval/static-1.39",
      "magpie-types": "/magpie-types/static-1.4822",
      "media-bridge-lib": "/media-bridge-lib/static-1.18513",
      "ui-addon-opt": "/ui-addon-opt/static-4.8153",
      "commerce-tours-lib": "/commerce-tours-lib/static-1.5668",
      "growth-onboarding-reliability": "/growth-onboarding-reliability/static-1.4856",
      "sales-checkout-service-client": "/sales-checkout-service-client/static-1.3445",
      "ai-addon-copilot-preview": "/ai-addon-copilot-preview/static-1.7476",
      "calling-cross-tab-library": "/calling-cross-tab-library/static-1.19036",
      "calling-lifecycle-usage-tracker": "/calling-lifecycle-usage-tracker/static-1.8050",
      "wootric-nps": "/wootric-nps/static-1.6749",
      "growth-monetization-service-types": "/growth-monetization-service-types/static-1.4291",
      "nav-client-types": "/nav-client-types/static-1.2123",
      "purchase-motions-api": "/purchase-motions-api/static-1.5440",
      "trials-service-types": "/trials-service-types/static-1.3692",
      "markdown-it": "/markdown-it/static-1.6",
      "cms-field-types": "/cms-field-types/static-1.4574",
      "underscore": "/underscore/static-1.8",
      "simple-logging-lib": "/simple-logging-lib/static-1.2818",
      "card-payment-highlight-lib": "/card-payment-highlight-lib/static-1.36412",
      "card-subscription-highlight-lib": "/card-subscription-highlight-lib/static-1.38768",
      "commerce-billing-lib": "/commerce-billing-lib/static-1.18408",
      "commerce-contract-lib": "/commerce-contract-lib/static-1.11041",
      "invoices-highlight-card-lib": "/invoices-highlight-card-lib/static-1.53902",
      "orders-highlight-card-lib": "/orders-highlight-card-lib/static-1.20795",
      "products-highlight-card-lib": "/products-highlight-card-lib/static-1.17043",
      "project-storage": "/project-storage/static-1.4500",
      "quotes-highlight-card-lib": "/quotes-highlight-card-lib/static-1.71037",
      "usage-based-billing-components-lib": "/usage-based-billing-components-lib/static-1.7926",
      "deal-intel-utils": "/deal-intel-utils/static-1.1132",
      "reporting-client-types": "/reporting-client-types/static-1.2376",
      "react-flip-move": "/react-flip-move/static-1.65",
      "FireAlarmUi": "/FireAlarmUi/static-1.4298",
      "sales-templates-service-types-lib": "/sales-templates-service-types-lib/static-1.3964",
      "ui-asset-management-lib": "/ui-asset-management-lib/static-1.10665",
      "emoji-regex": "/emoji-regex/static-1.7",
      "association-settings-lib": "/association-settings-lib/static-1.9556",
      "collaboration-sidebar": "/collaboration-sidebar/static-1.57054",
      "conditional-property-settings-modal": "/conditional-property-settings-modal/static-1.11870",
      "data-model-commons-lib": "/data-model-commons-lib/static-1.11855",
      "feedback-loader": "/feedback-loader/static-1.28792",
      "html-to-image": "/html-to-image/static-1.49",
      "object-definition-builder-lib": "/object-definition-builder-lib/static-1.6831",
      "property-management-iframe": "/property-management-iframe/static-1.12184",
      "property-usages-lib": "/property-usages-lib/static-1.5158",
      "reactflow": "/reactflow/static-1.59",
      "simple-data-table": "/simple-data-table/static-1.2095",
      "used-in-list-lib": "/used-in-list-lib/static-1.6686",
      "visual-association": "/visual-association/static-1.5614",
      "highcharts": "/highcharts/static-8.99",
      "reporting-visualizations": "/reporting-visualizations/static-1.58458",
      "ui-extensibility-client-types": "/ui-extensibility-client-types/static-1.3716",
      "automation-platform-service-types": "/automation-platform-service-types/static-1.2476",
      "ContentData": "/ContentData/static-1.67602",
      "email-portal-health-service-types": "/email-portal-health-service-types/static-1.745",
      "marketing-email-service-types": "/marketing-email-service-types/static-1.1770",
      "reactive-lib": "/reactive-lib/static-1.494",
      "content-whatsapp-service-types": "/content-whatsapp-service-types/static-1.236",
      "marketing-platform-lib": "/marketing-platform-lib/static-1.6602",
      "short-messages-app-service-client": "/short-messages-app-service-client/static-1.3780",
      "ui-tool-access": "/ui-tool-access/static-1.9911",
      "calling-orchestration-schema": "/calling-orchestration-schema/static-1.34926",
      "sales-views-client-types": "/sales-views-client-types/static-1.4059",
      "trellis-story-utils": "/trellis-story-utils/static-1.4291",
      "storybook-react": "/storybook-react/static-1.28",
      "hub-http-contrib": "/hub-http-contrib/static-1.2812",
      "interframe": "/interframe/static-3.4559",
      "tinymce-data": "/tinymce-data/static-1.39745",
      "ui-addon-sales-email": "/ui-addon-sales-email/static-1.4981",
      "codemirror": "/codemirror/static-5.90",
      "layout-dnd-components": "/layout-dnd-components/static-1.11974",
      "layout-dnd-utils": "/layout-dnd-utils/static-1.10949",
      "react-codemirror": "/react-codemirror/static-1.10394",
      "ui-brand-identity-lib": "/ui-brand-identity-lib/static-1.13705",
      "NamespacedHubStyle": "/NamespacedHubStyle/static-2.8867",
      "hls.js": "/hls.js/static-1.34",
      "js-cookie": "/js-cookie/static-1.18",
      "ai-rendering-library": "/ai-rendering-library/static-1.9204",
      "ai-settings-ui-library": "/ai-settings-ui-library/static-1.7350",
      "copilot-plugins": "/copilot-plugins/static-1.10415",
      "eligibility-engine-service-types": "/eligibility-engine-service-types/static-1.2973",
      "commerce-shared-components-lib": "/commerce-shared-components-lib/static-1.17834",
      "commerce-subscription-lib": "/commerce-subscription-lib/static-1.36345",
      "commerce-tools-ui-lib": "/commerce-tools-ui-lib/static-1.9712",
      "usage-tracker-session-replay": "/usage-tracker-session-replay/static-1.4787",
      "utility-belt": "/utility-belt/static-1.2310",
      "payments-enrollment-embed-lib": "/payments-enrollment-embed-lib/static-1.21870",
      "products-ui-components": "/products-ui-components/static-1.39278",
      "quotes-ui-lib": "/quotes-ui-lib/static-1.79756",
      "zustand": "/zustand/static-1.51",
      "accounting-integrations-ui-components": "/accounting-integrations-ui-components/static-1.6676",
      "invoices-ui-lib": "/invoices-ui-lib/static-1.53918",
      "commerce-products-api": "/commerce-products-api/static-1.1909",
      "SafeStorage": "/SafeStorage/static-1.4172",
      "invoices-iframe-lib": "/invoices-iframe-lib/static-1.55976",
      "quotes-modal-lib": "/quotes-modal-lib/static-1.101713",
      "platform-infra-nav-components": "/platform-infra-nav-components/static-1.7463",
      "reporting-ui-components": "/reporting-ui-components/static-2.63653",
      "subscription-experience-data-types": "/subscription-experience-data-types/static-1.14544",
      "association-translator": "/association-translator/static-1.2960",
      "crm-settings-header-lib": "/crm-settings-header-lib/static-1.8079",
      "settings-ui-nav": "/settings-ui-nav/static-2.9940",
      "chatspot-widget-iframe": "/chatspot-widget-iframe/static-1.20176",
      "collaboration-sidebar-common": "/collaboration-sidebar-common/static-1.1851",
      "crm-properties-common-lib": "/crm-properties-common-lib/static-1.5639",
      "ui-addon-draggable-compat": "/ui-addon-draggable-compat/static-2.4021",
      "property-management-common": "/property-management-common/static-1.4471",
      "d3": "/d3/static-1.7",
      "advanced-menus-core": "/advanced-menus-core/static-1.14769",
      "advanced-menus-lib": "/advanced-menus-lib/static-1.11751",
      "ExportDialog": "/ExportDialog/static-6.10156",
      "ui-memberships-settings-lib": "/ui-memberships-settings-lib/static-1.33343",
      "diff-match-patch": "/diff-match-patch/static-1.7",
      "layout-data-lib": "/layout-data-lib/static-1.9274",
      "browser-eslint": "/browser-eslint/static-2.57",
      "embedded-academy-lib": "/embedded-academy-lib/static-1.13390",
      "highlight.js": "/highlight.js/static-1.74",
      "reporting-action-components": "/reporting-action-components/static-1.40568",
      "reporting-snowflake": "/reporting-snowflake/static-1.55000",
      "ui-addon-react-router-dom": "/ui-addon-react-router-dom/static-1.9316",
      "growth-onboarding-empty-states": "/growth-onboarding-empty-states/static-1.5315",
      "InboxConnectUtils": "/InboxConnectUtils/static-4.14141",
      "payments-post-enroll-local-storage-lib": "/payments-post-enroll-local-storage-lib/static-1.4880",
      "qrcode-generator": "/qrcode-generator/static-1.64",
      "amplitude-session-replay-browser": "/amplitude-session-replay-browser/static-1.55",
      "marketplace-ui-apps-core": "/marketplace-ui-apps-core/static-1.17386",
      "stripe-embedded-components": "/stripe-embedded-components/static-1.7080",
      "commerce-permissions": "/commerce-permissions/static-1.520",
      "commerce-tax-lib": "/commerce-tax-lib/static-1.276",
      "property-description-translator": "/property-description-translator/static-1.3627",
      "commerce-analytics-service-client": "/commerce-analytics-service-client/static-1.3433",
      "totals-ui-components": "/totals-ui-components/static-1.22919",
      "reporting-plugins": "/reporting-plugins/static-1.9940",
      "reporting-reports": "/reporting-reports/static-1.66060",
      "edison-service-client-types": "/edison-service-client-types/static-1.158",
      "seamless-immutable": "/seamless-immutable/static-7.6",
      "simple-menus-core": "/simple-menus-core/static-1.14768",
      "simple-menus-lib": "/simple-menus-lib/static-1.16285",
      "academy-common-lib": "/academy-common-lib/static-1.12850",
      "dashboard-lib": "/dashboard-lib/static-1.80482",
      "share-with-third-party-component-lib": "/share-with-third-party-component-lib/static-1.8458",
      "developer-experience-shared-components": "/developer-experience-shared-components/static-1.10235",
      "marketplace-ui-client-types": "/marketplace-ui-client-types/static-1.16260",
      "marketplace-ui-common": "/marketplace-ui-common/static-1.18853",
      "ui-addon-integrations-directory-panel": "/ui-addon-integrations-directory-panel/static-2.7752",
      "stripe-connect-js": "/stripe-connect-js/static-1.63",
      "commerce-totals-service-types": "/commerce-totals-service-types/static-1.3608",
      "campaign-roi-lib": "/campaign-roi-lib/static-1.8182",
      "academy-service-client": "/academy-service-client/static-1.3449",
      "redux-actions": "/redux-actions/static-3.7",
      "apps-service-types": "/apps-service-types/static-1.3646",
      "oauth-service-types": "/oauth-service-types/static-1.4008",
      "react-window": "/react-window/static-1.13"
    },
    "project": "conversations-visitor-ui",
    "staticDomain": "//static.hsappstatic.net",
    "staticDomainPrefix": "//static.hsappstatic.net"
  }
};